export default __webpack_public_path__ + "static/media/AccountSettingMobile.523461dc.svg";